"use client";

import React from "react";
import CommonStringParser from "@/src/shared/components/CommonStringParser";
import InfoSheet from "./InfoSheet";
import ThingsToKnowTile from "./ThingsToKnowTile";

interface ICancellationPolicyProps {
  body: string;
}

const CancellationPolicy: React.FC<ICancellationPolicyProps> = ({ body }) => {
  const [open, setOpen] = React.useState(false);
  const html = body.split("\n").join("<br/>");

  return (
    <>
      <ThingsToKnowTile
        iconSrc="/icons/listing/listing_things_cancellation.svg"
        title="Cancellation policy"
        onOpen={() => setOpen(true)}
      >
        <span className="line-clamp-3 break-words">
          <CommonStringParser dangerHtml={html} />
        </span>
      </ThingsToKnowTile>
      <InfoSheet
        open={open}
        onClose={() => setOpen(false)}
        title="Cancellation policy"
      >
        <div className="mt-4 break-words text-base leading-relaxed text-ink-dark">
          <CommonStringParser dangerHtml={html} />
        </div>
      </InfoSheet>
    </>
  );
};

export default CancellationPolicy;
